<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">Manage media</div>
</div>

<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
  <bt-page-header title="Styles media" subtitle="Check the media status of each style and add styles to orders" icon="fa-solid fa-images"></bt-page-header>

  <div class="flex column margin-bottom">
    <b>
      <i class="fa fa-industry"></i>
      Warehouse:
    </b>

    <div class="flex center">
      <div class="flex center margin-top-small fix-width">
        <div class="flex-1 fix-width-ware border padding-small flex center between">
          @if (styleFilters.warehouses && styleFilters.warehouses.length) {
            <span>{{ styleFilters.warehouses[0].description }}</span>

            <mat-icon class="hover small" (click)="cleanFilter('warehouses')">close</mat-icon>
          } @else {
            Select a warehouse
          }
        </div>
        <button type="button" class="flex-0 radius-left-none" (click)="openWarehouseFilterModal()">
          <i class="fa-solid fa-edit"></i>
          Edit
        </button>
      </div>
    </div>
  </div>

  <div class="flex center margin-bottom-small">
    <i class="fa-solid fa-filter margin-right-smallest"></i>
    <b>Filters:</b>
  </div>

  <div class="flex wrap gap margin-bottom-small">
    <div class="filter-chip" [ngClass]="!styleFilters.styleCode ? '' : 'selected'">
      @if (styleFilters.styleCode) {
        <div class="flex center hover" (click)="openStyleCodesFilter()">
          <b class="margin-right-smallest">Style Code:</b>
          {{ styleFilters.styleCode }}
        </div>

        <mat-icon class="hover" (click)="cleanFilter('styleCode')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleCodesFilter()">
          Style Code
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.statuses || !styleFilters.statuses.length ? '' : 'selected'">
      @if (styleFilters.statuses && styleFilters.statuses.length) {
        <div class="flex center hover" (click)="openStatusFilterModal()">
          <b class="margin-right-smallest">Status:</b>

          @for (status of styleFilters.statuses; track status; let last = $last) {
            {{ status.name }}
            @if (!last) {
              ,
            }
          }
        </div>

        <mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStatusFilterModal()">
          Status
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.brands || !styleFilters.brands.length ? '' : 'selected'">
      @if (styleFilters.brands && styleFilters.brands.length) {
        <div class="flex center hover" (click)="openBrandFilterModal()">
          <b class="margin-right-smallest">Brand:</b>

          @for (brand of styleFilters.brands; track brand; let last = $last) {
            {{ brand.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openBrandFilterModal()">
          Brand
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.categories || !styleFilters.categories.length ? '' : 'selected'">
      @if (styleFilters.categories && styleFilters.categories.length) {
        <div class="flex center hover" (click)="openCategoryFilterModal()">
          <b class="margin-right-smallest">Category:</b>
          @for (category of styleFilters.categories; track category; let last = $last) {
            {{ category.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('categories')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCategoryFilterModal()">
          Category
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!styleFilters.styleGroups || !styleFilters.styleGroups.length ? '' : 'selected'"
    >
      @if (styleFilters.styleGroups && styleFilters.styleGroups.length) {
        <div class="flex center hover" (click)="openStyleGroupFilterModal()">
          <b class="margin-right-smallest">Style Group:</b>
          @for (styleGroup of styleFilters.styleGroups; track styleGroup; let last = $last) {
            {{ styleGroup.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('styleGroups')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleGroupFilterModal()">
          Style Group
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!styleFilters.styleDescriptions || !styleFilters.styleDescriptions.length ? '' : 'selected'"
    >
      @if (styleFilters.styleDescriptions && styleFilters.styleDescriptions.length) {
        <div class="flex center hover" (click)="openStyleDescriptionFilterModal()">
          <b class="margin-right-smallest">Style Description:</b>
          @for (styleDescription of styleFilters.styleDescriptions; track styleDescription; let last = $last) {
            {{ styleDescription.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('styleDescriptions')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleDescriptionFilterModal()">
          Style Description
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!styleFilters.collections || !styleFilters.collections.length ? '' : 'selected'"
    >
      @if (styleFilters.collections && styleFilters.collections.length) {
        <div class="flex center hover" (click)="openCollectionFilterModal()">
          <b class="margin-right-smallest">Collection:</b>
          @for (collection of styleFilters.collections; track collection; let last = $last) {
            {{ collection.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('collections')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCollectionFilterModal()">
          Collection
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.purposes || !styleFilters.purposes.length ? '' : 'selected'">
      @if (styleFilters.purposes && styleFilters.purposes.length) {
        <div class="flex center hover" (click)="openPurposeFilterModal()">
          <b class="margin-right-smallest">Purpose:</b>
          @for (purpose of styleFilters.purposes; track purpose; let last = $last) {
            {{ purpose.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('purposes')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openPurposeFilterModal()">
          Purpose
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.genders || !styleFilters.genders.length ? '' : 'selected'">
      @if (styleFilters.genders && styleFilters.genders.length) {
        <div class="flex center hover" (click)="openGenderFilterModal()">
          <b class="margin-right-smallest">Gender:</b>
          @for (gender of styleFilters.genders; track gender; let last = $last) {
            {{ gender.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('genders')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openGenderFilterModal()">
          Gender
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!styleFilters.teams || !styleFilters.teams.length ? '' : 'selected'">
      @if (styleFilters.teams && styleFilters.teams.length) {
        <div class="flex center hover" (click)="openTeamFilterModal()">
          <b class="margin-right-smallest">Team:</b>
          @for (team of styleFilters.teams; track team; let last = $last) {
            {{ team.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('teams')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openTeamFilterModal()">
          Team
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>
  </div>

  @if (styles && styles.items && styles.items.length) {
    <div class="flex center between full-width">
      <div class="flex center gap">
        @if (selectedStyles.length > 0) {
          <span class="hover" (click)="openSelectedStylesModal()">
            <b class="margin-right-smallest">{{ selectedStyles.length }}</b>
            selected
          </span>

          <span class="primary flex center hover" (click)="downloadImages(selectedStyles)">
            <i class="fa fa-download margin-right-smallest"></i>
            Download selected media
          </span>

          @if (styleFilters.warehouses && styleFilters.warehouses.length == 1 && !loading) {
            <span class="red flex center hover" (click)="openAddToOrderModal(selectedStyles)">
              <i class="fa fa-arrow-right margin-right-smallest"></i>
              Add selected to order
            </span>
          }
          <span class="red flex center hover" (click)="deselectAll()">
            <i class="fa fa-xmark margin-right-smallest"></i>
            Deselect all
          </span>
        }
      </div>

      <div class="flex center">
        <span
          class="hover primary margin-right"
          [ngClass]="canDownloadStyleResumeeList() ? '' : 'disabled'"
          (click)="downloadStyleResumeeList()"
        >
          <i class="fa fa-download margin-right-smallest"></i>
          Download media list (.xlsx)
        </span>

        <bt-paginator
          [pageNumber]="styles.currentPage"
          [pageSize]="styles.size"
          [totalNumber]="styles.totalCount"
          (clickPage)="pageEvent($event)"
        ></bt-paginator>
      </div>
    </div>

    <table class="margin-top-smallest">
      <tr>
        <th></th>
        <th class="t-hidden">Brand</th>
        <th>Style</th>

        <th>Status</th>
        <th>Orders</th>
        <th class="t-hidden">Warehouse</th>
        <th>Action</th>

        <!--<th>Collection</th>
				 <th>Purpose</th>
				<th>Team</th>
				<th>Action</th> -->
      </tr>

      @for (item of styles.items; track item) {
        <tr>
          <td>
            <div class="flex center justify-center">
              @if (item.status.id == styleStatus.Shooting) {
                <i class="fa-solid fa-lock grey"></i>
              } @else {
                <i
                  class="primary-dark hover  hover fa {{
                    isSelected(item.modelId) ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
                  }}"
                  (click)="selectStyle(item)"
                ></i>
              }
            </div>
          </td>
          <td class="t-hidden">{{ item.brand.name }}</td>

          <td>
            <div class="flex column start">
              <div class="flex wrap">{{ item.code }} - {{ item.name }} - {{ item.gender.name }}</div>

              <span class="small grey">
                {{ item.category.name }} -
                {{ item.styleGroup.name != item.category.name ? item.styleGroup.name + ' - ' : '' }}
                {{ item.collection?.id }} {{ item.collection?.name }}
              </span>
            </div>
          </td>

          <td>
            <div class="flex column start fix-height">
              @if (item.status.id == styleStatus.MissingImages) {
                <div class="radius bg-orange padding-right-smallest padding-left-smallest">Missing media</div>
                <div class="small nowrap grey">Please upload media</div>
              } @else if (item.status.id == styleStatus.Shooting) {
                <div class="radius bg-primary white padding-right-smallest padding-left-smallest">
                  Shooting in progress
                </div>
                <div class="small nowrap grey">Editing is not available</div>
              } @else if (item.status.id == styleStatus.Confirmed) {
                <div class="radius bg-green white padding-right-smallest padding-left-smallest">Confirmed media</div>
                <div class="small nowrap grey">All media confirmed</div>
              }
            </div>
          </td>
          <td class="nowrap">
            @if (item.orders.length) {
              @if (item.orders.length == 1) {
                <!-- http://localhost:8080/company/order-view/2/order-detail-info -->
                <a
                  class="primary hover"
                  [routerLink]="['/company/order-view/' + item.orders[0].id + '/order-detail-info']"
                >
                  <i class="fa fa-solid fa-angle-right margin-right-smallest"></i>
                  Order #{{ item.orders[0].id }}
                </a>
              } @else {
                <span class="flex center">
                  <span class="hover flex center primary" (click)="openOrdersModal(item.orders)">
                    <i class="fa fa-solid fa-angles-right margin-right-smallest"></i>
                    {{ item.orders.length }} orders
                  </span>
                </span>
              }
            } @else {
              <span class="grey margin-left-smallest flex center">-</span>
            }
          </td>
          <td class="t-hidden nowrap">
            @let warehouses = getWarehousesByStyle(item);
            @if (warehouses.length == 0) {
              No warehouses
            } @else {
              <span class="flex center">
                <span class="hover flex center primary" (click)="openWarehousesModal(item)">
                  <i class="fa fa-solid fa-angle-right margin-right-smallest"></i>
                  @if (warehouses.length == 1) {
                    {{ warehouses[0].description }}
                  } @else {
                    {{ warehouses.length }} warehouses
                  }
                </span>
              </span>
            }
          </td>
          <td class="nowrap">
            <div class="flex center">
              <a [routerLink]="['/company/style-info/' + item.modelId]" class="hover flex center primary">
                <i class="fa-solid fa-edit margin-right-smallest"></i>
                Manage media
              </a>

              @if (item.status.id == styleStatus.Confirmed) {
                <a class="margin-left hover flex center primary" (click)="downloadImages([item])">
                  <i class="fa fa-download margin-right-smallest"></i>
                  Download media
                </a>
              }

              @if (styleFilters.warehouses && styleFilters.warehouses.length == 1 && !loading) {
                <span class="margin-left flex center hover red" (click)="openAddToOrderModal([item])">
                  <i class="fa fa-arrow-right margin-right-smallest"></i>
                  Add to order
                </span>
              }
            </div>
          </td>
        </tr>
      }
    </table>

    <bt-paginator
      [pageNumber]="styles.currentPage"
      [pageSize]="styles.size"
      [totalNumber]="styles.totalCount"
      [totalPages]="styles.totalPages"
      (clickPage)="pageEvent($event)"
    ></bt-paginator>
  }

  @if (styles.items.length == 0 && !loading) {
    <div class="flex center bg-light-grey padding-largest justify-center margin-top">
      <div class="flex column center gap">
        <i class="fa fa-search fa-2xl margin-bottom grey"></i>
        <span>No styles found</span>
      </div>
    </div>
  }
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
